import { Navigate, Link } from 'react-router-dom';
import { authClient } from '../lib/auth-client';
import { OfficeClock } from '../components/OfficeClock';

export default function MyProfilePage() {
  const { data: session, isPending } = authClient.useSession();
  if (isPending) return <main className="grid min-h-screen place-items-center text-sm text-[var(--ink-soft)]">Loading profile…</main>;
  if (!session?.user) return <Navigate to="/auth" replace />;
  return <main className="min-h-screen bg-[var(--paper)] px-4 py-6 text-[var(--ink)] sm:px-6">
    <section className="mx-auto max-w-2xl">
      <Link to="/dashboard" className="text-sm font-semibold text-[var(--accent)] hover:underline">← Back to workspace</Link>
      <header className="mt-6 border-b border-[var(--line)] pb-5">
        <p className="text-sm text-[var(--ink-soft)]">Account settings</p>
        <h1 className="mt-1 text-3xl font-semibold tracking-tight">My profile</h1>
        <p className="mt-2 text-sm text-[var(--ink-soft)]">{session.user.name || session.user.email}</p>
      </header>
      <section aria-label="Office time clock" className="mt-6 rounded-xl border border-[var(--line)] bg-[var(--paper)] p-5 shadow-[0_1px_0_rgba(15,23,42,0.02)]">
        <h2 className="text-lg font-semibold">Office time</h2>
        <p className="mt-1 text-sm text-[var(--ink-soft)]">Clock in when your shift starts and clock out when it ends. Start lunch to record an unpaid break. Each completed shift is recorded separately in Timesheets.</p>
        <div className="mt-4"><OfficeClock /></div>
      </section>
    </section>
  </main>;
}
